import type { ComponentProps } from "react"
import cn from "@/v2-ui/utils/utils.cn"
import {
  formatLatency,
  getProviderName,
} from "@/v2-backoffice-client/uptime/uptime.utils"
import type { UptimeInlineFragment } from "@/v2-backoffice-client/uptime/inline/__types__/uptime.inline.fragment"

export type UptimeDashboardSlowRowProps = ComponentProps<"div"> & {
  target: UptimeInlineFragment
}

// One row in the "Slow" lane of the wall-display dashboard. Pairs
// the current latency reading with a 24-hour latency sparkline so
// the operator can tell "spike just happened" apart from "drifted
// up over a day" at a glance.
function UptimeDashboardSlowRow(props: UptimeDashboardSlowRowProps) {
  const { target, className, ...divProps } = props

  const current = target.AvgDurationMs24h ?? target.LastDurationMs ?? null
  const baseline = target.P95DurationMs90d ?? target.AvgDurationMs90d ?? null
  const ratio =
    current != null && baseline != null && baseline > 0
      ? current / baseline
      : null
  const provider = getProviderName(target)

  return (
    <div className={cn("uptime-dashboard-row", className)} {...divProps}>
      <div className="uptime-dashboard-row-main">
        <div className="uptime-dashboard-row-name">
          {target.Name ?? target.Identifier}
        </div>
        <div className="uptime-dashboard-row-reason">
          {formatLatency(current)}
          {ratio != null && (
            <>
              {" "}
              <span className="uptime-dashboard-row-ratio">
                ({ratio.toFixed(1)}× baseline)
              </span>
            </>
          )}
        </div>
        <div className="uptime-dashboard-row-meta">
          <span className="uptime-dashboard-row-provider">{provider}</span>
          <span className="uptime-dashboard-row-aside">
            baseline {formatLatency(baseline)}
          </span>
        </div>
      </div>
    </div>
  )
}

export default UptimeDashboardSlowRow
